export type loggedOutUserKind = null
export enum AvailableUserKinds {
  Band = 'band',
  Influencer = 'influencer',
}
export type IdentifiedUserKind = `${AvailableUserKinds}` // => 'band' | 'influencer'
export type UserKind = IdentifiedUserKind | loggedOutUserKind
